import { Switch, Field, Label } from "@headlessui/react";
import { XIcon, CheckIcon } from "@phosphor-icons/react";
import clsx from "clsx";

export default function FinanceSwitch({
    enabled,
    setEnabled,
    label,
    displayLabel = true,
}: {
    enabled: boolean;
    setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
    label: string;
    displayLabel?: boolean;
}) {
    return (
        <Field className="cC-flex cC-items-center cC-content-center cC-justify-between cC-gap-2 cC-rounded-md">
            {displayLabel && (
                <Label as="span" className="cC-text-sm hover:cC-cursor-pointer">
                    {label.length > 0 ? (
                        <span className="cC-font-medium cC-text-gray-900">{label}</span>
                    ) : (
                        <span className="cC-text-[0.9rem] cC-text-gray-500">
                            Will you require finance?
                        </span>
                    )}
                </Label>
            )}
            <Switch
                checked={enabled}
                onChange={setEnabled}
                className={clsx(
                    enabled ? "" : "cC-bg-gray-200",
                    `cC-relative cC-inline-flex cC-h-6 cC-w-14 cC-flex-shrink-0 cC-cursor-pointer cC-rounded-full cC-border-2 cC-border-[--cC-primary] cC-transition-colors cC-duration-200 cC-ease-in-out focus:cC-outline-none focus:cC-ring-2 focus:cC-ring-offset-2`,
                )}
                style={
                    {
                        backgroundColor: enabled ? "var(--cC-primary)" : "",
                        "--tw-ring-color": "var(--cC-primary)",
                    } as React.CSSProperties
                }
            >
                <span className="cC-sr-only">Will you require finance?</span>
                <span
                    className={clsx(
                        enabled ? "cC-translate-x-5" : "cC-translate-x-0",
                        "cC-pointer-events-none cC-relative cC-inline-block cC-h-5 cC-w-8 cC-transform cC-rounded-full cC-bg-white cC-shadow cC-ring-0 cC-transition cC-duration-200 cC-ease-in-out",
                    )}
                >
                    <span
                        className={clsx(
                            enabled
                                ? "cC-opacity-0 cC-duration-100 cC-ease-out"
                                : "cC-opacity-100 cC-duration-200 cC-ease-in",
                            "cC-absolute cC-inset-0 cC-flex cC-h-full cC-w-full cC-items-center cC-justify-center cC-transition-opacity",
                        )}
                        aria-hidden="true"
                    >
                        <span className="cC-text-[0.7rem] cC-font-medium cC-text-[--cC-primary] cC-px-3 cC-py-1">
                            No
                        </span>
                        {/* <XIcon
                            className="cC-h-3 cC-w-3 cC-stroke-[--cC-primary] cC-stroke-[10%]"
                            size={32}
                        /> */}
                        
                    </span>
                    <span
                        className={clsx(
                            enabled
                                ? "cC-opacity-100 cC-duration-200 cC-ease-in"
                                : "cC-opacity-0 cC-duration-100 cC-ease-out",
                            "cC-absolute cC-inset-0 cC-flex cC-h-full cC-w-full cC-items-center cC-justify-center cC-transition-opacity",
                        )}
                        aria-hidden="true"
                    >
                        <span className="cC-text-[0.7rem] cC-font-medium cC-text-[--cC-primary]">
                            Yes
                        </span>
                        {/* <CheckIcon
                            className="cC-h-3 cC-w-3 cC-stroke-[--cC-primary] cC-stroke-[10%]"
                            size={32}
                        /> */}
                    </span>
                </span>
                
            </Switch>
        </Field>
    );
}
